import React from 'react'
import { Tabs, Tab, Box } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles'
import desertFloraTheme from '../../../styles/desertFloraTheme'
import DisposalFacilitiesTable from './DisposalFacilitiesTable'
import RolloffRatesTable from './RolloffRatesTable'
import DisposalQuickCalculator from './DisposalQuickCalculator'

const TabPanel = ({ children, value, index }) => {
  if (value !== index) return null
  return <Box>{children}</Box>
}

const DisposalDashboard = ({ url }) => {
  const [tab, setTab] = React.useState(0)

  return (
    <ThemeProvider theme={desertFloraTheme}>
      <div style={{ background: 'var(--bg, #f4efe4)', minHeight: '100%', padding: '0 0 24px' }}>
        <Tabs
          value={tab}
          onChange={(e, newVal) => setTab(newVal)}
          indicatorColor="primary"
          textColor="primary"
          style={{ marginBottom: 8, borderBottom: '1px solid var(--line, #e0d8c2)' }}
        >
          <Tab label="Disposal Facilities" />
          <Tab label="Roll-off Rates" />
          <Tab label="Quick Calculator" />
        </Tabs>
        <TabPanel value={tab} index={0}>
          <DisposalFacilitiesTable url={url} />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <RolloffRatesTable url={url} />
        </TabPanel>
        <TabPanel value={tab} index={2}>
          <DisposalQuickCalculator url={url} />
        </TabPanel>
      </div>
    </ThemeProvider>
  )
}

export default DisposalDashboard
